<template>
  <div id="app">
    <router-view></router-view>
    <v-footer></v-footer>
    <!--login></login-->
  </div>
</template>

<script type = "text/ecamscript-6">
/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import goodsCoupon from '@/components/goodsCoupon/goodsCoupon'
import vFooter from '@/components/footer/footer'
import login from '@/components/login/login'
export default {
  name: 'App',
  data(){
      return{
      url:'',
      obj:{}
      }
  },
  created(){
     var href = window.location.search.replace("?","");
     console.log(href)
     if(href){
       var params = href.split("&");

       for(var i =0; i < params.length; i++){
         this.obj[params[i].split("=")[0]] = params[i].split("=")[1]
       }

       console.log(this.obj)
       this.login ()
     }

  },
  methods:{
    //登录保存openid
    // login (){
    //   axios.defaults.baseURL = ''
    //   this.url = "https://api.weixin.qq.com/sns/oauth2/access_token?appid=wx4646afdce94db0a3&secret=d0f26ffa60a4dcc87b13f09915c31850&code="+this.obj.code+"&grant_type=authorization_code"
    //   console.log(this.url )
    //   this.$ajax.autoService
    //       .login(this.url)
    //       .then((res) => {
    //         localStorage.setItem("openid", res.data.openid);
    //         localStorage.setItem("ACCESS_TOKEN",res.data.ACCESS_TOKEN)
    //       }, (res) => {
    //           console.log("error")
    //           this.REQUIRE = true;
    //       })
    // }
  },
  mounted(){
    
  },
components:{
  'goodsCoupon':goodsCoupon,
  'v-footer':vFooter,
  'login':login
},
}

// location.assign("/#/item/41829677273?tkUrl=%2F%2Fuland.taobao.com%2Fcoupon%2Fedetail%3Fe%3DrNhKdVBfjBI8Clx5mXPEKrq3KAr1FCqVpW9RFcno5Ld2VYLheOYrFVeLipz%252B4PodsZoBQGDYpyAV9ujECgJuSDkbExR7zmWVJTNWSR3CwiY%253D%26app_pvid%3D0b08283815348186480274872e%26ptl%3DfloorId%3A2836%3Bapp_pvid%3A0b08283815348186480274872e%3Btpp_pvid%3A100_11.182.43.227_210758_4891534818648036759%26mt%3D1%26union_lens%3DlensId%3A0b085fb1_0907_1655a520112_dfea&coupon=200")
</script>
<style lang="stylus">
  @import './common/stylus/common.styl'
    #app
      width:750px
      min-height:100%
      text-size-adjust:none
</style>



// WEBPACK FOOTER //
// src/App.vue